/*
  What an SBC solution is, before the user has done anything to it.

  The Streamlined SBC and the solver describe a squad the same way: what it
  is worth, what it costs, how much of it the club covers, how long it takes.
  They get there from different backends, so the shape they agree on and the
  rules that turn counts into display decisions live here, testable without
  rendering either app.
*/
/*
  Roughly how long a squad takes to assemble: laying it out, plus a search and a
  bid per player that has to be bought. A frontend guess until the backend has
  an opinion; nothing else reads it.
*/
const SETUP_MINUTES = 3;
const MINUTES_PER_TRANSFER = 50 / 60;
export const estimatedBuildMinutes = (transferCount) => Math.round(SETUP_MINUTES + transferCount * MINUTES_PER_TRANSFER);
/**
 * Whether the club covers any of the squad at all. The summary paints the club
 * count green from the first player, so the rule lives here rather than in the
 * stylesheets of every screen that shows it.
 */
export const clubCoversAny = (ownedCount) => ownedCount > 0;
/**
 * Whether the club covers the squad outright. The tick is reserved for this: a
 * partial count is a number, not something achieved.
 */
export const clubCoversAll = (ownedCount, playerCount) => playerCount > 0 && ownedCount === playerCount;
export const solutionFacts = ({ totalValue, transferCost, ownedCount, playerCount, transferCount, }) => {
    const transfers = transferCount ?? Math.max(0, playerCount - ownedCount);
    return {
        totalValue,
        transferCost,
        clubValue: totalValue - transferCost,
        ownedCount,
        playerCount,
        transferCount: transfers,
        isAnyFromClub: clubCoversAny(ownedCount),
        isFullyFromClub: clubCoversAll(ownedCount, playerCount),
        estimatedMinutes: estimatedBuildMinutes(transfers),
    };
};
export const solutionSummaryFacts = (counts) => ({
    ...solutionFacts(counts),
    costRemaining: counts.transferCost,
});
//# sourceMappingURL=solutionFacts.js.map